import PropTypes from 'prop-types'
import React from 'react'
import classNames from 'classnames'
import { connect } from 'react-redux'

import { BACK_CAPTIONS, BACK_TYPES, BACK_SIDES } from './constants.jsx'
import { helpers } from 'react-wot-bootstrap'
import { playHoverSound, playClickSound } from 'state/actions/sounds'

import styles from './Back.scss'

export const Back = (props) => {
    const handleMouseDown = () => props.playClickSound()
    const handleHover = () => props.playHoverSound()

    const sideClass = props.caption ? styles[`base__${props.side}`] : null

    const className = classNames(styles.base, styles[`base__${props.type}`], sideClass, {
        [styles.base__cn]: helpers.isChineseLanguage(),
    })

    return (
        <button
            className={className}
            onClick={props.handleClick}
            onMouseDown={handleMouseDown}
            onMouseEnter={handleHover}
        >
            <span className={styles.icon} />
            {props.caption && <span className={styles.caption}>{props.caption}</span>}
            {props.children}
        </button>
    )
}

Back.propTypes = {
    caption: PropTypes.node,
    handleClick: PropTypes.func.isRequired,
    playHoverSound: PropTypes.func.isRequired,
    playClickSound: PropTypes.func.isRequired,
    type: PropTypes.oneOf(Object.values(BACK_TYPES)).isRequired,
    side: PropTypes.oneOf(Object.values(BACK_SIDES)).isRequired,
}

Back.defaultProps = {
    caption: BACK_CAPTIONS.back,
    type: 'back',
    side: 'left',
}

Back.CAPTIONS = BACK_CAPTIONS
Back.TYPES = BACK_TYPES
Back.SIDES = BACK_SIDES

const mapDispatchToProps = { playHoverSound, playClickSound }

export default connect(null, mapDispatchToProps)(Back)



// WEBPACK FOOTER //
// ./components/Back/Back.jsx